import React from 'react';
import s from './Price.scss';
import { data } from '../../../globals';
import {
  isLocalCurrencyOnRight,
  isLocalCyrillic,
} from '../../../services/window-utils';
import { formatNumber } from '../../../constants';
import classNames from 'classnames';
import { useTranslation } from '@wix/wix-i18n-config';
import {
  InjectedExperimentsProps,
  withExperiments,
} from '@wix/wix-experiments-react';

interface PriceProps extends InjectedExperimentsProps {
  amount: number;
  isSticky: boolean;
  currency?: string;
  discountAmount?: number;
}

const Price = (props: PriceProps) => {
  const { t } = useTranslation();
  const { amount, discountAmount, currency, isSticky } = props;
  const { decimalSeparator, groupSeparator } = data.currency;
  const amountWithSeparators = formatNumber(
    amount,
    decimalSeparator,
    groupSeparator,
  );
  const rightCurrency = isLocalCurrencyOnRight() ? currency : ' ';
  const leftCurrency = !isLocalCurrencyOnRight() ? currency : null;
  const formattedAmount = isLocalCurrencyOnRight()
    ? `${amountWithSeparators}${currency}`
    : `${currency}${amountWithSeparators}`;

  const renderPrice = () => {
    return (
      <>
        <div
          className={classNames(s.price, { [s.isSticky]: isSticky })}
          data-hook="compareTable-price"
        >
          <div
            className={s.currencyLeft}
            data-hook="compareTable-price-currency-left"
          >
            {leftCurrency}
          </div>
          <div
            className={classNames(s.amount, {
              [s.isLocalCyrillic]: isLocalCyrillic(),
            })}
            data-hook="compareTable-price-amount"
          >
            {discountAmount ? discountAmount : amountWithSeparators}
          </div>
          <div>
            <div
              className={s.currencyRight}
              data-hook="compareTable-price-currency-right"
            >
              {rightCurrency}
            </div>
            <div className={s.aMonth} data-hook="compareTable-price-aMonth">
              {t('compare.price.aMonth')}
            </div>
          </div>
        </div>
        <div className={classNames(s.bottomData, { [s.isSticky]: isSticky })}>
          <div
            className={s.discountPrice}
            data-hook="compareTable-price-original"
          >
            {discountAmount ? formattedAmount : null}
          </div>
        </div>
      </>
    );
  };

  const renderFree = () => {
    return (
      <div className={s.priceFree} data-hook="compare-price-free">
        {t('package.free.price')}
      </div>
    );
  };

  return (
    <div className={s.root} data-hook="compareTable-price-component">
      {!amount ? renderFree() : renderPrice()}
    </div>
  );
};

export default withExperiments(Price);
